/**
 * Created by dmitry on 13.10.2025
 */

VictoryMessageAction = (f) => f();